module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      open: _vm.open, inline: !_vm.open
    }
  }, [(_vm.primary && !_vm.open) ? _c('openButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "html": '&#x25B6;'
    },
    on: {
      "click": function($event) {
        _vm.open = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.primary && _vm.open) ? _c('openButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "html": '&#x25BC;'
    },
    on: {
      "click": function($event) {
        _vm.open = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.charOpen)
    }
  }), _vm._v(" "), (!_vm.open && !_vm.expanded) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.expanded = true
      }
    }
  }, [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(key, index) {
    return (_vm.open || _vm.expanded) ? _c('div', [_c('span', {
      staticClass: "key",
      domProps: {
        "textContent": _vm._s(key)
      }
    }), _vm._v(": "), _c('objectTreeNode', {
      attrs: {
        "primary": _vm.open
      },
      model: {
        value: (_vm.value[key]),
        callback: function($$v) {
          _vm.$set(_vm.value, key, $$v)
        },
        expression: "value[key]"
      }
    }), (!_vm.open && index < _vm.items.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.charClose)
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-258cbfbe!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-object-view/ObjectTreeNodeComplex.vue
// module id = 1534
// module chunks = 2